export const STATUS_MAP = {
  0: "RUNNING",
  1: "TERMINATING",
  2: "COMPLETED",
  3: "CANCELLED",
  4: "UNRUNNABLE",
  5: "IN QUEUE"
};

export const STATUS_MAP_COLOR: { [key: number]: string } = {
  0: "#3CCF4E",
  1: "#FF6B35",
  2: "#00BCD4",
  3: "#FF4C4C",
  4: "#B0B0B0",
  5: "#FFD600"
};
